import styled from 'styled-components';

export const AllowedDomainWrap = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 10px;
  gap: 10;
`;
export const AllowedDomainListWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-height: 150px;
  overflow-y: auto;
  padding: 10px;
  margin-top: 5px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  & .ant-checkbox-group {
    gap: 5px;
  }
`;
